"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var urijs_1 = __importDefault(require("urijs"));
var query_string_1 = require("query-string");
var utils_1 = require("./utils");
exports.pipe = function () {
    var fs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fs[_i] = arguments[_i];
    }
    return function (t) { return fs.reduce(function (v, f) { return f(v); }, t); };
};
var replaceQuestionmarksWithAmpersands = function (queryString) { return queryString.replace(/\?/g, '&'); };
var removeDuplicateAmpersands = function (queryString) { return queryString.replace(/&{2,}/g, '&'); };
var removeLeadingAmpersand = function (queryString) { return (queryString.indexOf('&') === 0
    ? queryString.substring(1)
    : queryString); };
var cleanQueryString = exports.pipe(replaceQuestionmarksWithAmpersands, removeDuplicateAmpersands, removeLeadingAmpersand);
exports.parseHref = function (href) {
    /**
     * Decode url twice,to ensure proper decoding
     */
    var decodedHref = decodeURIComponent(decodeURIComponent(href));
    var uri = urijs_1.default(decodedHref);
    var uriQuery = uri.query();
    var uriPath = uri.path();
    var firstElementFromPath = utils_1.getValidValue(uriPath.split('/')[1] || null);
    var queryString = cleanQueryString(uriQuery);
    var query = query_string_1.parse(queryString);
    return {
        firstElementFromPath: firstElementFromPath,
        queryString: queryString,
        query: query,
    };
};
//# sourceMappingURL=href.js.map